import { render, staticRenderFns } from "./Congratulation.vue?vue&type=template&id=6577d128&"
import script from "./Congratulation.vue?vue&type=script&lang=js&"
export * from "./Congratulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports